import type { ComponentTheme } from '../types/component-theme';

import { ThemeVariants } from './constants/theme-variants';

export default {
    slots: {
        root: 'mb-8 flex items-center gap-3',
        line: 'h-px flex-1',
        label: 'text-xs uppercase tracking-wider'
    },
    variants: {
        theme: {
            [ThemeVariants.Dark]: {
                root: 'text-slate-500',
                line: 'bg-white/10'
            },
            [ThemeVariants.Light]: {
                root: 'text-slate-400',
                line: 'bg-slate-200'
            }
        }
    }
} satisfies ComponentTheme;
